import React, {useEffect, useState} from 'react';
import { Button } from "carbon-components-react";
import { useNavigate } from "react-router-dom";
import EnrollmentCell from './enrollment-cell';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import { useDispatch, useSelector } from 'react-redux';
import { updateEnrollments } from '../../redux/actions/enrollments-actions';

const NewHire = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const enrollments = useSelector(s => s.enrollments);
    const [currentStep, setCurrentStep] = useState();

    useEffect(() => {
      if(Array.isArray(enrollments))
        return; 
      setCurrentStep(enrollments.currentStep);
    }, [enrollments])

    const start = () => {
      let enroll = {...enrollments};
      enroll.currentStep = 1;
      dispatch(updateEnrollments(enroll));
      navigate("/Employee");


    }
    
    return ( 
        <>

        <div className="mb-8">
          <div className="font-bold text-3xl">Welcome to Clayco!</div>
          <div className="font-bold text-3xl">We're happy you are here.</div>
        </div>
        <div className="mb-8">
          <div className="text-xl">Please proceed to start your enrollment process.</div>

        </div>
        <div className="">
          <Button
            onClick={start}
          >
            Start Benefits Enrollment
          </Button>
        </div>
        <p className='my-8'>
        <strong>Questions?</strong>  Contact Beth Mellenthin  at 314-592-2206 or Sara Benignus at 314-614-5880 or e-mail <a href='mailto:benefits@claycorp.com'>benefits@claycorp.com</a> . 
        </p>

        </>
     );
}
 
export default NewHire;